(function () {
  'use strict';

  //
  // Wait until the theme has completed initialization before proceeding
  //
  document.addEventListener('page:loaded', function () {
    ////////////////////////////////////////////////////////////////////////
    //
    // Global objects
    //
    ////////////////////////////////////////////////////////////////////////

    //
    // Variant object
    //
    var variant = null;

    //
    // Discounts object
    //
    var discounts = [];

    //
    // Notes time debounce object
    //
    var notesDebounce;

    ////////////////////////////////////////////////////////////////////////
    //
    // Custom Quantity Dropdown and Price Display functions
    //
    ////////////////////////////////////////////////////////////////////////

    //
    // Get pricing for quantity including any appliable discounts
    //
    function getPricingForQuantity(unitPrice, quantity, discounts) {
      try {
        //Ensure global theme object is available
        if (window.theme == null) {
          //Missing global theme object, return empty discount pricing object
          return {
            price: '',
            compareAtPrice: '',
            discount: '',
            discountAmount: '',
            newUnitPrice: '',
          };
        }

        //Ensure unit price is valid
        if (!Number.isFinite(unitPrice)) {
          //Invalid unit price, return empty discount pricing object
          return {
            price: '',
            compareAtPrice: '',
            discount: '',
            discountAmount: '',
            newUnitPrice: '',
          };
        }

        //Find eligible discounts
        if (Array.isArray(discounts) && discounts.length > 0) {
          //Discounts exist
          var eligibleDiscounts = discounts.filter(function (discount) {
            return quantity >= discount.minQuantity;
          });

          //Check for eligible discounts
          if (eligibleDiscounts.length > 0) {
            //Eligible discounts found for quantity, sort them
            eligibleDiscounts.sort(function (a, b) {
              return b.percentDiscount - a.percentDiscount;
            });

            //return the discounted price and discount text
            return {
              price: window.theme.Currency.formatMoney(unitPrice * quantity * (1 - eligibleDiscounts[0].percentDiscount / 100)),
              compareAtPrice: window.theme.Currency.formatMoney(unitPrice * quantity),
              discount: Math.trunc(eligibleDiscounts[0].percentDiscount) + '%' + ' Off',
              discountAmount: window.theme.Currency.formatMoney(unitPrice * quantity - unitPrice * quantity * (1 - eligibleDiscounts[0].percentDiscount / 100)),
              newUnitPrice: window.theme.Currency.formatMoney(unitPrice * (1 - eligibleDiscounts[0].percentDiscount / 100)),
            };
          }
        }

        //No discount, return standard discount pricing object
        return {
          price: window.theme.Currency.formatMoney(unitPrice * quantity),
          compareAtPrice: '',
          discount: '',
          discountAmount: '',
          newUnitPrice: '',
        };
      } catch (err) {
        //Error occured, return empty discount pricing object
        return {
          price: '',
          compareAtPrice: '',
          discount: '',
          discountAmount: '',
          newUnitPrice: '',
        };
      }
    }

    //
    // Update product page pricing block
    //
    function updatePrice(variant, qty, discounts) {
      if (document.getElementById('ppd')) {
        return;
      }
      if (qty == null || qty < 1) {
        //Grab the quantity from the DOM if its missing
        if (document.querySelector("input[name='quantity']")) {
          qty = Number(document.querySelector("input[name='quantity']").value);
        }
      }

      //Ensure quantity is valid
      if (!Number.isFinite(qty)) {
        //Invalid quantity
        return;
      }

      //Get pricing
      var pricing = getPricingForQuantity(variant.price, qty, discounts);

      //Update pricing block
      var priceElement = document.querySelector('[data-product-price]');
      if (!priceElement) return;
      var compareAtElement = document.querySelector('[data-product-price-wrap]');
      var saveElement = document.querySelector('[data-save-price]');
      if (pricing.discount) {
        //Price element
        var priceSpans = priceElement.getElementsByTagName('span');
        for (var i = 0; i < priceSpans.length; i++) {
          priceSpans[i].innerHTML = pricing.price;
        }

        //Compare at element
        var compareAtSpans = compareAtElement.getElementsByTagName('span');
        for (var i = 0; i < compareAtSpans.length; i++) {
          compareAtSpans[i].innerHTML = pricing.compareAtPrice;
        }
        compareAtElement.classList.remove('hide');

        //Save element
        saveElement.innerHTML = 'Save ' + pricing.discountAmount;
        saveElement.classList.remove('hide');

        //Unit price element
        var unitpriceElement = document.querySelector('[data-unit-price]');
        unitpriceElement.innerHTML = pricing.newUnitPrice + ' per unit';
      } else {
        //Price element
        var priceSpans = priceElement.getElementsByTagName('span');
        for (var i = 0; i < priceSpans.length; i++) {
          priceSpans[i].innerHTML = pricing.price;
        }

        //Compare at element
        var compareAtSpans = compareAtElement.getElementsByTagName('span');
        for (var i = 0; i < compareAtSpans.length; i++) {
          compareAtSpans[i].innerHTML = '';
        }
        compareAtElement.classList.add('hide');

        //Save element
        saveElement.innerHTML = '';
        saveElement.classList.add('hide');

        //Unit price element
        var unitpriceElement = document.querySelector('[data-unit-price]');
        unitpriceElement.innerHTML = window.theme.Currency.formatMoney(variant.price) + ' per unit';
      }
    }

    ////////////////////////////////////////////////////////////////////////
    //
    // Customization Editor functions
    //
    ////////////////////////////////////////////////////////////////////////

    //
    // Check if browser is mobile or tablet
    //
    function isMobileOrTabletBrowser() {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }

    //
    // Show/hide customization button as needed
    //
    function updateCustomizationButton(variant) {
      try {
        var qtyRange = document.getElementById('qty__range');
        if (qtyRange && isMobileOrTabletBrowser()) {
          qtyRange.style.display = 'none';
        }
      } catch (e) {}

      var customizeButton = document.querySelector('[data-customize-item]');

      //Check if the product metadata indicates customizable
      var customizable = document.querySelector('[data-product-customizable]');
      if (customizable && variant.sku) {
        if (customizeButton.classList.contains('visually-hidden')) {
          customizeButton.classList.remove('visually-hidden');
        }
      } else {
        //Hide the customization button
        if (!customizeButton.classList.contains('visually-hidden')) {
          customizeButton.classList.add('visually-hidden');
        }
      }
    }

    ////////////////////////////////////////////////////////////////////////
    //
    // Product Page Initialization
    //
    ////////////////////////////////////////////////////////////////////////

    //
    // Initialize the product page
    //
    function initializeProductPage() {
      if (document.getElementById('ppd')) {
        return;
      }

      try {
        try {
          if (document.getElementsByClassName('flickity-page-dots') && document.getElementsByClassName('flickity-page-dots')[0]) {
            if (document.getElementsByClassName('flickity-page-dots')[0].getElementsByTagName('li').length > 15) {
              document.getElementsByClassName('flickity-page-dots')[0].style.display = 'none';
            }
          }
        } catch (ignored) {
          console.error(ignored);
        }

        var materialDropdownWrapper = document.querySelector('[data-handle="material"]');
        if (materialDropdownWrapper != null) {
          var materialDropdown = materialDropdownWrapper.children[0];
          var stakesDropdownWrapper = document.querySelector('[data-handle="include-yard-sign-stakes-2-each"]');
          if (stakesDropdownWrapper != null) {
            var stakesDropdownEl = stakesDropdownWrapper.parentNode;
            var stakesDropdown = stakesDropdownWrapper.children[0];
            if (materialDropdown.value != 'Corrugated Plastic') {
              stakesDropdownEl.style.display = 'none';
              stakesDropdown.value = 'No';
            }
            materialDropdown.addEventListener('change', function () {
              if (this.value === 'Corrugated Plastic') {
                stakesDropdownEl.style.display = 'block';
              } else {
                stakesDropdownEl.style.display = 'none';
                stakesDropdown.value = 'No';
              }
            });
          }
        }
      } catch (e) {}

      //Try to get the current variant from the DOM, since it was not provided as an argument
      var variantEl = document.querySelector('[data-current-variant-json]');
      if (variantEl) {
        variant = JSON.parse(variantEl.innerHTML);
      } else {
        var productEl = document.querySelector('[data-variant-json]');
        if (productEl) {
          variant = JSON.parse(productEl.innerHTML)[0];
        }
      }

      if (variant) {
        //Apply any applicable discounts
        var discountCollEl = document.querySelector('[data-discount-id-json]');
        var discountEl = document.querySelector('[data-discount-json]');
        if (discountEl && discountEl.innerHTML && discountEl.innerHTML.trim()) {
          var discountDefs = JSON.parse(discountEl.innerHTML);
          if (discountDefs && discountCollEl && discountCollEl.innerHTML && discountCollEl.innerHTML.trim()) {
            if (document.querySelector('input[name="properties[Discounts]"]')) {
              document.querySelector('input[name="properties[Discounts]"]').remove();
            }
            var addToCartBtn = document.querySelector('[data-add-to-cart]');
            var discountProp = document.createElement('input');
            discountProp.setAttribute('type', 'hidden');
            discountProp.setAttribute('name', 'properties[_discountCollection]');
            discountProp.value = discountCollEl.innerHTML.trim();
            addToCartBtn.parentNode.appendChild(discountProp);

            discounts = discountDefs;
          }
        }

        //Update the price
        updatePrice(variant, null, discounts);

        //Show/Hide the customize button
        updateCustomizationButton(variant);

        //handle slider change
        var qtySlider = document.getElementById('qty__range');
        qtySlider.removeEventListener('input', onQtySliderChange);
        qtySlider.addEventListener('input', onQtySliderChange);
      }
    }

    //
    // Handle quantity slider change
    //
    function onQtySliderChange(e) {
      var qtyInput = document.getElementsByName('quantity')[0];
      qtyInput.value = e.target.value;
      qtyInput.dispatchEvent(new Event('change'));
    }

    //
    // Display cart item regular price based on discount
    //
    function updateRegularPriceDisplay(cartItemEl, discountPresent) {}

    //
    // Display cart item discount price based on discount
    //
    function updateDiscountPriceDisplay(cartItemEl, discountData) {}

    //
    // Display cart item discount description based on discount
    //
    function updateDiscountDescriptionDisplay(cartItemEl, discountData) {}

    //
    // Set the discounted cart subtotal
    //
    function setDiscountedCartSubtotal(draftOrderSubtotal) {}

    //
    // Remove discount pricing
    //
    function removeDiscountPricing() {}

    //
    // Handle notes change
    //
    function handleNotesChange(e) {}

    //
    // Handle variant quantity change
    //
    document.addEventListener('variant:quantityChange', function (e) {
      if (e.detail && e.detail.quantity) {
        //Update the price with the new quantity
        updatePrice(variant, Number(e.detail.quantity), discounts);

        var qtySlider = document.getElementById('qty__range');
        qtySlider.value = Number(e.detail.quantity);
      }
    });

    //
    // Handle variant change
    //
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) {
        //Update the variant object
        variant = e.detail.variant;

        //Update the price
        updatePrice(variant, null, discounts);

        //Show/Hide the customize button
        updateCustomizationButton(variant);

        //Clone the color selector, if applicable
        try {
          var custSec = document.querySelector('[md-customization-sec]');
          var colorPicker = document.querySelector('fieldset[data-handle=color]');
          var colorWrapper = document.getElementById('customization-color-wrapper');
          if (colorPicker && colorWrapper && custSec.style.display == 'block') {
            var clone = colorPicker.closest('div').cloneNode(true);
            colorWrapper.textContent = '';
            colorWrapper.style.display = 'block';
            colorWrapper.appendChild(clone);
          }
        } finally {
        }
      }
    });

    //
    // Handle variant loaded (modal product page)
    //
    document.addEventListener('variant:loaded', function (e) {
      if (e.detail && e.detail.variant) {
        //Update the variant object
        variant = e.detail.variant;

        //Initialize the product page
        initializeProductPage();
      }
    });

    //Initialize the product page if applicable
    initializeProductPage();
  });

  //
  // On quantity change
  //
  const onIslandQuantityChange = (e) => {
    const { optionNumber, quantity } = e?.detail ?? {};
    selectQuantity(optionNumber, quantity);
  };

  //
  // On variant change
  //
  const onVariantChange = (e) => {
    const variantId = e?.detail?.variant?.id ?? null;

    //Update product quantity selector props
    document.querySelectorAll('[data-react-shadow="ProductQuantitySelector"]').forEach((el) => mergeProps(el, { activeVariant: variantId }));

    //Update product price display props
    document.querySelectorAll('[data-react-shadow="ProductPriceDisplay"]').forEach((el) => mergeProps(el, { activeVariant: variantId }));
  };

  //
  // Select a quantity on the theme input
  //
  const selectQuantity = (optionNumber, quantity) => {
    const wrapper = document.querySelector(`.variant-input[data-index="option${optionNumber}"][data-value="${quantity}"]`);
    if (wrapper) {
      const input = wrapper.querySelector('input[type="radio"]');
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  };

  //
  // Merge and dispatch props changes for react-islands components
  //
  const mergeProps = (host, patch) => {
    const current = JSON.parse(host?.dataset?.props || '{}');
    const next = { ...current, ...patch };
    host.dataset.props = JSON.stringify(next);
    host?.dispatchEvent(new CustomEvent('island:props'));
  };

  //
  // Handle events from react-islands components
  //
  document.addEventListener('DOMContentLoaded', () => {
    const productQuantitySelector = document.getElementById('pqs');
    if (!productQuantitySelector) return;

    if (productQuantitySelector.dataset.listenersBound === 'true') return;
    productQuantitySelector.dataset.listenersBound = 'true';

    document.addEventListener('island:quantity-change', onIslandQuantityChange);
    document.addEventListener('variant:change', onVariantChange);
  });
})();
